/**
 * WebKit view-transition bugs keyed on the engine version (iOS version on iPhone/iPad,
 * Safari version on macOS). Consumed by the runtime gates in browser.ts.
 */
export const webKitViewTransitionBugs = (
    version: number,
    iDevice: boolean,
) => ({
    // https://bugs.webkit.org/show_bug.cgi?id=320238 (open)
    // Same-document view transitions flash the floating iOS 26+ Safari header/footer solid whenever
    // the root snapshot or a named element overlaps them. Workaround: no root crossfade there.
    rootChromeFlash: iDevice && version >= 26,

    // https://bugs.webkit.org/show_bug.cgi?id=321084 (open, rdar://184715664)
    // The old snapshot of a playing <video> is blank on the first frame of a view transition,
    // so the room -> grid morph flashes empty.
    videoSnapshotBlank: version >= 26,

    // https://bugs.webkit.org/show_bug.cgi?id=302256 (open, rdar://164882934)
    // backdrop-filter is dropped for the duration of a view transition, so a filter-only Backdrop
    // is invisible until the transition ends (confirmed Safari 27.0, 2026-09-08). Backdrop falls
    // back to a scrim + saturate under `.webkit-vt-no-backdrop-filter`.
    backdropFilterDropped: version >= 26,

    // https://webkit.org/blog/17640/webkit-features-for-safari-26-2/ (fixed in 26.2, rdar://154886047)
    // position: fixed / sticky content is clipped during view transitions.
    fixedClipping: version >= 26 && version < 26.2,

    // https://webkit.org/blog/18162/release-notes-for-safari-technology-preview-248/ (fixed in STP 248, rdar://181100818)
    // Inserting a CSS rule while a view transition is active snaps the group animation to its
    // final state. video.js writes its `vjs-styles-dimensions` <style> when a player is created,
    // which happens inside the room-open transition. Not reproducible on Safari 27.0 (2026-09-08),
    // so bounded to 26.x.
    cssRuleSnap: version >= 26 && version < 27,
})

export type WebKitViewTransitionBugs = ReturnType<
    typeof webKitViewTransitionBugs
>
